(function () {
  var root = document.querySelector('[data-mo-article]');
  if (!root) return;
  var body = root.querySelector('[data-mo-content]');
  if (!body) return;

  function norm(url) {
    if (!url) return '';
    var f = url.split('?')[0].split('#')[0].split('/').pop().toLowerCase();
    f = f.replace(/\.(png|jpe?g|webp|gif|avif)$/, '');
    f = f.replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/, '');
    f = f.replace(/_\d{2,4}x\d{0,4}$/, '');
    return f;
  }

  var hero = root.getAttribute('data-mo-hero');
  if (hero) {
    var imgs = body.querySelectorAll('img');
    var limit = Math.min(imgs.length, 2);
    for (var i = 0; i < limit; i++) {
      if (norm(imgs[i].getAttribute('src')) === norm(hero)) {
        var wrap = imgs[i].parentElement;
        imgs[i].parentNode.removeChild(imgs[i]);
        if (wrap && (wrap.tagName === 'P' || wrap.tagName === 'FIGURE') && wrap.textContent.trim() === '' && !wrap.querySelector('img')) {
          wrap.parentNode.removeChild(wrap);
        }
        break;
      }
    }
  }

  Array.prototype.forEach.call(body.querySelectorAll('table'), function (t) {
    if (t.parentElement && t.parentElement.classList.contains('mo-table-scroll')) return;
    var w = document.createElement('div');
    w.className = 'mo-table-scroll';
    t.parentNode.insertBefore(w, t);
    w.appendChild(t);
  });

  var faqRe = /^(faq|questions fr[ée]quentes|questions courantes)/i;
  var faqHead = null;
  Array.prototype.forEach.call(body.querySelectorAll('h2'), function (h) {
    if (!faqHead && faqRe.test(h.textContent.trim())) faqHead = h;
  });

  if (faqHead) {
    var pairs = [];
    var box = document.createElement('div');
    box.className = 'mo-faq';
    faqHead.parentNode.insertBefore(box, faqHead.nextSibling);
    var node = box.nextSibling;
    var current = null;
    while (node) {
      var next = node.nextSibling;
      if (node.nodeType === 1 && node.tagName === 'H2') break;
      if (node.nodeType === 1 && node.tagName === 'H3') {
        var d = document.createElement('details');
        var s = document.createElement('summary');
        s.textContent = node.textContent.trim();
        var ans = document.createElement('div');
        ans.className = 'mo-faq__a';
        d.appendChild(s);
        d.appendChild(ans);
        box.appendChild(d);
        current = { el: ans, q: s.textContent, a: '' };
        pairs.push(current);
        node.parentNode.removeChild(node);
      } else if (current && node.nodeType === 1) {
        current.a += node.textContent.trim() + ' ';
        current.el.appendChild(node);
      }
      node = next;
    }
    if (pairs.length) {
      var sc = document.createElement('script');
      sc.type = 'application/ld+json';
      sc.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: pairs.map(function (p) {
          return {
            '@type': 'Question',
            name: p.q,
            acceptedAnswer: { '@type': 'Answer', text: p.a.trim() }
          };
        })
      });
      document.head.appendChild(sc);
    } else {
      box.parentNode.removeChild(box);
    }
  }

  var toc = root.querySelector('[data-mo-toc]');
  if (toc) {
    var list = toc.querySelector('ol');
    var h2s = Array.prototype.filter.call(body.querySelectorAll('h2'), function (h) {
      return h.textContent.trim().length > 0;
    });
    if (h2s.length >= 3) {
      h2s.forEach(function (h, i) {
        if (!h.id) h.id = 'mo-s' + (i + 1);
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        list.appendChild(li);
      });
      toc.hidden = false;
      if (window.innerWidth >= 1100) toc.open = true;
      if ('IntersectionObserver' in window) {
        var links = list.querySelectorAll('a');
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            Array.prototype.forEach.call(links, function (l) {
              if (l.getAttribute('href') === '#' + e.target.id) {
                l.classList.add('is-current');
              } else {
                l.classList.remove('is-current');
              }
            });
          });
        }, { rootMargin: '-80px 0px -70% 0px' });
        h2s.forEach(function (h) { obs.observe(h); });
      }
    }
  }

  var dataEl = document.getElementById('mo-cited-products');
  if (dataEl) {
    var products = [];
    try { products = JSON.parse(dataEl.textContent); } catch (err) { products = []; }
    var placed = 0;
    products.forEach(function (p) {
      if (placed >= 3 || !p.handle) return;
      var link = body.querySelector('a[href*="/products/' + p.handle + '"]');
      if (!link) return;
      var block = link;
      while (block.parentElement && block.parentElement !== body) block = block.parentElement;
      if (block.parentElement !== body) return;
      var card = document.createElement('a');
      card.className = 'mo-prod';
      card.href = p.url;
      var html = '';
      if (p.image) {
        html += '<img class="mo-prod__img" src="' + p.image + '" alt="" loading="lazy" width="160" height="160">';
      }
      html += '<div class="mo-prod__body"><div class="mo-prod__label">La création citée</div><div class="mo-prod__name">' + p.title + '</div>';
      if (p.meta) html += '<div class="mo-prod__meta">' + p.meta + '</div>';
      html += '<div class="mo-prod__cta">Découvrir la bague →</div></div>';
      card.innerHTML = html;
      block.parentNode.insertBefore(card, block.nextSibling);
      placed++;
    });
  }
})();
